// Make urlParams and debugMode global
var urlParams = new URLSearchParams(window.location.search);
var debugMode = urlParams.get('debug');

// Check if debug mode is enabled (global)
// urlParams moved to funcs.js to avoid duplication
var INITIALIZED=false; var INITIALIZED2=false;
const LANGS=['EN','RU','DE'];

// Enhanced Language Detection with Cookie Support
function detectLanguageWithCookies() {
    // Сначала проверяем, есть ли переменная с сервера
    if (typeof window.LANG_FROM_SERVER !== 'undefined') {
        return window.LANG_FROM_SERVER;
    }
    
    // Если jQuery доступен, используем cookie систему
    if (typeof $ !== 'undefined' && $.cookie) {
        // 1. Проверяем cookie
        let lang = $.cookie('preferred_language');
        if (lang && LANGS.includes(lang.toUpperCase())) {
            return lang.toUpperCase();
        }
        
        // 2. Проверяем браузер
        const browserLang = (navigator.language || navigator.userLanguage).split('-')[0].toUpperCase();
        if (LANGS.includes(browserLang)) {
            // Сохраняем в cookie
            $.cookie('preferred_language', browserLang, { expires: 365, path: '/' });
            return browserLang;
        }
        
        // 3. Дефолт английский
        $.cookie('preferred_language', 'EN', { expires: 365, path: '/' });
        return 'EN';
    }
    
    // Fallback к старой системе если jQuery не доступен
    const browserLang = (navigator.language || navigator.userLanguage).split('-')[0].toUpperCase();
    return LANGS.includes(browserLang) ? browserLang : LANGS[0];
}

// Backward compatibility - инициализируем только если не определена с сервера
const LANG_BROWSER = (typeof window.LANG_BROWSER !== 'undefined') ? window.LANG_BROWSER : detectLanguageWithCookies();

//"https://cloud.mail.ru/public/h8YA/DQXFXAnoP"
